<template>
  <div>
    <!-- AppHeaderNew -->
    <AppHeaderNew />

    <section class="pages-banner">
      <div class="container text-center banner-box h-100">
        <h1>About</h1>
      </div>
    </section>

    <div class="container inner-page-box">
      <div class="container breadcrumb-box">
        <p>
          <router-link :to="{name: 'home'}">Home</router-link>> About Us
        </p>
      </div>
      
        <b-card-text>
          <strong>About</strong>
        </b-card-text>
        <b-card-text>
          Amej Pay is a digital payment gateway that has its own safe and fast payment network. You can easily load and fund it and withdraw it. Every hotel will be the merchant of Amej pay. Amej Pay provides easy financial transactions globally through QR codes.
        </b-card-text>

        <b-card-text>
          <strong>Features of Amej Pay:</strong>
        </b-card-text>

        <b-card-text>
          <ul>
            <li>Easy payment through QR codes</li>
            <li>Reduce the trouble of currency exchange</li>
            <li>Easy wallet app</li>
            <li>Transparent transaction</li>
            <li>Support other networks</li>
            <li>Easy load and withdrawal of fund</li>
            <li>Online Recharge using Debit/Credit card</li>
          </ul>
        </b-card-text>

        <b-card-text>
          Amej Pay is a payment system where customers can send, receive and pay from anywhere using mobile phone and internet service. Also, merchants can receive the payment of the products and services within a minute using Amej Pay. Amej Pay can be used to pay the online bills, mobile recharge, electricity and water bills, movies tickets, travel tickets, flights, college and school fees, and so forth. You do not have to queue for payment. You can just pay sitting at your home or anywhere else easily.
        </b-card-text>

        <b-card-text>
          Our vision is to provide access to the world population with the latest and best technology envisioning decentralized systems. With this our vision is to provide the best online payment service with the most reliable and easy way through our platform.
        </b-card-text>

        <b-card-text>
          <strong>Contact Us:</strong>
        </b-card-text>

        <b-card-text>
          <strong>AmejPay Headquarters &mdash; Asia Pacific (APAC)</strong><br/>
          S&amp;J Building, 104, Rachaparop Soi 1, Phayathai,<br/>
          Bangkok 10400, Thailand<br/>
          www.amejpay.com<br/>
          <a href="mailto:apac@amejpay.com">apac@amejpay.com</a>, <a href="mailto:support@amejpay.com">support@amejpay.com</a><br/>
          Phone No: <a href="tel:+66626513995">+66 626513995</a><br/>

        </b-card-text>
          <strong>Follow Us:</strong>
        <b-card-text>
          
        </b-card-text>
          <strong>Facebook:</strong> <a href="https://www.facebook.com/amej.pay/" target="_blank">https://www.facebook.com/amej.pay/</a><br/>
          <strong>Twitter:</strong> <a href="https://twitter.com/amejpay" target="_blank">https://twitter.com/amejpay</a><br/>
          <strong>Youtube:</strong> <a href="https://www.youtube.com/channel/UCP_6007tMa2Y0z0njRclE-w" target="_blank">https://www.youtube.com/channel/UCP_6007tMa2Y0z0njRclE-w</a><br/>
          <strong>Instagram:</strong> <a href="https://www.instagram.com/amejpay/" target="_blank">https://www.instagram.com/amejpay/</a><br/>
          <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/company/amejpay" target="_blank">https://www.linkedin.com/company/amejpay</a><br/>
        <b-card-text>
          
        </b-card-text>

        <b-card-text>
          
        </b-card-text>

    </div>

    <!-- FooterNew -->
    <AppFooterNew />
  </div>
</template>

<script type="text/javascript">
import AppHeaderNew from "../reuseable_components/HeaderNew";
import AppFooterNew from "../reuseable_components/FooterNew";

export default {
  name: "pricacyPolicy",
  components: {
    AppHeaderNew,
    AppFooterNew,
  },
  data() {
    return {
      //
    };
  },
};
</script>